module.exports = __webpack_public_path__ + "static/3-2ce40429052ae6c80b281aa751c2f5a8.png";